import DirectoryBody from './DirectoryBody'

export default DirectoryBody;